import customaxios from ".";
import axios from "axios";
import { serverAddress } from "../config/env";
import Cookies from "js-cookie";

const baseURL = serverAddress.toString() || "";

/** Exchange ADO access token for an application session. */
export const login = (data: any) => {
  return axios({
    method: "POST",
    url: `${baseURL}/login/postSSOValidation`,
    data: {
      ...data,
      applicationId: 1,
    },
  });
};

/** Exchange ADO access token for an application session. */
export const loginOut = () => {
                            const storedData = Cookies.get("userDetails") || "{}";
              const token = JSON.parse(storedData)?.fetchAPI;
  return axios({
    method: "PUT",
    url: `${baseURL}/logout`,
    headers: {
      Authorization: `${token}`,
    },
  });
};

/** Use refresh token to obtain a new access token. */
export const refreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) {
    throw new Error("No refresh token found");
  }
  return customaxios({
    method: "POST",
    url: "/refresh-token",
    headers: {
      Authorization: `${refreshToken}`,
    },
  });
};
/** Change account password. */
export const changePassword = (data: unknown) => {
  return customaxios({
    method: "POST",
    url: "/change-password",
    data,
  });
};

/** Anonymous contact-us submission. */
export const contactUs = (data: unknown) => {
  return axios({
    method: "POST",
    url: `${baseURL}/contact-us`,
    data,
  });
};

/** Get companies list to populate request access form. */
export const getCompanyNamesInRequestAccess = () => {
  return axios({
    method: "GET",
    url: `${baseURL}/request-access/company-names`,
  });
};
/** Submit a request for access. */
export const requestAccess = (data: any) => {
  return axios({
    method: "POST",
    url: `${baseURL}/request-access`,
    data,
  });
};
